var React = require('react');

function IconCode (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M374.3 422.7l-245.5 90.1 245.6 90.9c3.9 1.5 6.5 5.2 6.5 9.4v30.8c0 7-7 11.8-13.6 9.3l-298-113.6c-3.9-1.5-6.4-5.2-6.4-9.3v-34.9c0-4.2 2.6-7.9 6.5-9.4l298-112.7c6.5-2.5 13.5 2.4 13.5 9.4v30.6c0 4.2-2.6 8-6.6 9.4zm84.5 308.8h-26.5c-6.8 0-11.6-6.6-9.5-13L555.5 296c1.3-4.2 5.2-7 9.5-7h27c6.8 0 11.6 6.6 9.5 13L468.3 724.5c-1.3 4.2-5.2 7-9.5 7zm500.5-194.3l-304.4 116c-6.5 2.5-13.6-2.3-13.6-9.3v-30.8c0-4.2 2.6-7.9 6.5-9.4l245.6-90.9-245.5-90.1c-3.9-1.4-6.6-5.2-6.6-9.4v-30.7c0-7 7-11.8 13.5-9.4l298 112.7c3.9 1.5 6.5 5.2 6.5 9.4v41.9z"}));
}

IconCode.displayName = "IconCode";

IconCode.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCode;

IconCode.default = IconCode;
